import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import {
  veersaLogo,
  collapseArrowImg,
  logoutImg,
  settingsImg,
  veersaLogoCollapse,
  openArrowImg,
  logoutBlueIcon,
  settingBlueIcon,
} from "../../common/icons";
import { useAzureADAuth } from "../../config/use-azure-ad";
import { ModuleList } from "../../mock-data/Sidebar";
import { useSelector, useDispatch } from "react-redux";
import { getMyAssignedTasks } from "../../redux/actions/task";

/** Keep My Points (veersaPoints) immediately after My Tasks when both appear in the sidebar. */
function orderVeersaPointsAfterMyTasks(moduleKeys) {
  const list = [...moduleKeys];
  const vIdx = list.indexOf("veersaPoints");
  if (vIdx === -1) return list;
  list.splice(vIdx, 1);
  const mIdx = list.indexOf("myTasks");
  if (mIdx === -1) {
    return ["myTasks", "veersaPoints", ...list.filter((k) => k !== "myTasks" && k !== "veersaPoints")];
  }
  list.splice(mIdx + 1, 0, "veersaPoints");
  return list;
}

export default function Sidebar({ changePage, pageName }) {
  const { logoutAzureAD } = useAzureADAuth();
  const dispatch = useDispatch();
  const [collapse, setCollapse] = useState(false);
  const [mouseHover, setMouseHover] = useState("-1");
  const [selected, setSelected] = useState("");
 
  const { userData } = useSelector(({ USER }) => USER);
  const { myAssignedTasks } = useSelector(({ TASK }) => TASK || { myAssignedTasks: [] });
  
  // Calculate active tasks count (open + in progress)
  const getActiveTasksCount = () => {
    if (!myAssignedTasks || !Array.isArray(myAssignedTasks)) return 0;
    return myAssignedTasks.filter(task => {
      const status = task.status?.toLowerCase();
      return status === 'open' || status === 'in progress';
    }).length;
  };

  // Load tasks when component mounts and user data is available
  useEffect(() => {
    if (userData && userData.data) {
      dispatch(getMyAssignedTasks());
    }
  }, [userData, dispatch]);
 
  const signOutHandler = () => {
    logoutAzureAD();
  };
 
  useEffect(() => {
    if (userData && userData.data) {
      const pathname = window.location.pathname;
     
      if (pathname.includes('myTasks')) {
        setSelected("myTasks");
      } else if (pathname.includes('projectAllocation')) {
        setSelected("projectAllocation");
      } else if (pathname.includes('timeSheet')) {
        setSelected("timeSheet");
      } else if (pathname.includes('projectManagement')) {
        setSelected("projectManagement");
      } else if (pathname.includes('reporting')) {
        setSelected("reporting");
      } else if (pathname.includes('invoiceTracker')) {
        setSelected("invoiceTracker");
      } else if (pathname.includes('clientAdmin')) {
        setSelected("clientAdmin");
      } else if (pathname.includes('projectAdmin')) {
        setSelected("projectAdmin");
      } else if (pathname.includes('vendorAdmin')) {
        setSelected("vendorAdmin");
      } else if (pathname.includes('vendorSowAdmin')) {
        setSelected("vendorSowAdmin");
      } else if (pathname.includes('sow') && !pathname.includes('vendorSow')) {
        setSelected("sow");
      } else if (pathname.includes('skillTracker')) {
        setSelected("skillTracker");
      } else if (pathname.includes('viewAttendance')) {
        setSelected("viewAttendance");
      } else if ((pathname.includes('correctAttendance') || pathname.includes('RegularizeAttendance')) && userData.data.roleName === "Operational Admin") {
        setSelected("17");
      } else if (pathname.includes('trainingAndSession')) {
        setSelected("trainingAndSession");
      } else if (pathname.includes('sessionFeedback')) {
        setSelected("sessionFeedback");
      } else if (pathname.includes('resourceAllocation') || pathname.includes('AllocationDashboard')) {
        setSelected("19");
      } else if (pathname.includes('veersaPoints')) {
        setSelected("22");
      } else if (pathname.includes('pointsDashboard')) {
        setSelected("23");
      } else if (pathname.includes('settings')) {
        setSelected("settings");
      }
    }
  }, [userData]);

  const getSidebarClass = (moduleId) => {
    let sidebarClass = "";
    if (moduleId === selected) sidebarClass = "sidebarItemsSelected";
    else sidebarClass = "sidebarItems";
    return sidebarClass;
  };
 
  return (
    <div className={`sidebarOuterContainer ${collapse ? "" : "minWidthClass"}`}>
      <div
        className={
          collapse === false
            ? "veersaLogoContainer"
            : "veersaLogoContainer-collapse"
        }
      >
        <img
          className={collapse === false ? "veersaLogo" : "veersaLogo-collapse"}
          src={collapse === false ? veersaLogo : veersaLogoCollapse}
          id="veersalogo"
          alt=""
        />
      </div>
      {collapse === true ? <div className="divider" /> : ""}
      <div className="sidebarWrapper">
        <div>
          {userData && userData.data.roleName === "Operational Admin" ? (
            // Show specific modules for Operational Admin role
            (() => {
              const operationalAdminModules = ['myTasks', 'projectAllocation', 'timeSheet', 'viewAttendance', 'trainingAndSession', 'correctAttendance'];
              return operationalAdminModules.map((moduleKey, index) => {
                let module = ModuleList.find(e => e.key === moduleKey);
                if (module) {
                  let sidebarClass = getSidebarClass(module.id);
                  if(module.id !== "9" && module.id !== "16") {
                    // Special handling for My Tasks to show task count
                    const isMyTasks = moduleKey === 'myTasks';
                    const activeTasksCount = isMyTasks ? getActiveTasksCount() : 0;
                    
                    return (
                      <div
                        key={index}
                        className={sidebarClass}
                        onClick={() => {
                          changePage(module.name);
                          setSelected(module.id);
                        }}
                        onMouseOver={() => setMouseHover(module.id)}
                        onMouseOut={() => setMouseHover(-1)}
                        style={{
                          display:
                            pageName === "Dashboard" && module.id !== "1" ? "none" : "",
                        }}
                      >
                        <img
                          className="itemImage"
                          src={
                            mouseHover === module.id || selected === module.id
                              ? module.imgHover
                              : module.img
                          }
                          alt=""
                        />
                        {collapse === false ? (
                          <div className="itemName">
                            {module.name}
                            {isMyTasks && activeTasksCount > 0 && (
                              <span className="task-count">{activeTasksCount}</span>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    );
                  }
                }
                return null;
              });
            })()
          ) : userData && userData.data.roleName === "Project Manager" ? (
            // Show modules for Project Manager role - including Allocation Dashboard from database + essential modules
            (() => {
              const userTabs = Object.keys(userData.data.tabs || {});
              
              // Start with My Tasks first, then add other modules
              const allModules = ['myTasks'];
              
              // Add user tabs from database (excluding myTasks to avoid duplicates)
              userTabs.forEach(tab => {
                if (tab !== 'myTasks' && !allModules.includes(tab)) {
                  allModules.push(tab);
                }
              });
              
              // Add resourceAllocation for Project Manager (Allocation Dashboard)
              if (!allModules.includes('resourceAllocation')) {
                allModules.push('resourceAllocation');
              }
              if (!allModules.includes('sowAllocations')) {
                allModules.push('sowAllocations');
              }

              if (!allModules.includes('veersaPoints')) {
                allModules.push('veersaPoints');
              }

              const orderedModules = orderVeersaPointsAfterMyTasks(
                allModules.filter((k) => k !== "pointsDashboard")
              );

              return orderedModules.map((moduleName, index) => {
                let module = ModuleList.find(e => e.key === moduleName);
                if (module) {
                  let sidebarClass = getSidebarClass(module.id);
                  if(module.id !== "9" && module.id !== "16") {
                    // Special handling for My Tasks to show task count
                    const isMyTasks = moduleName === 'myTasks';
                    const activeTasksCount = isMyTasks ? getActiveTasksCount() : 0;
                    
                    return (
                      <div
                        key={index}
                        className={sidebarClass}
                        onClick={() => {
                          changePage(module.name);
                          setSelected(module.id);
                        }}
                        onMouseOver={() => setMouseHover(module.id)}
                        onMouseOut={() => setMouseHover(-1)}
                        style={{
                          display:
                            pageName === "Dashboard" && module.id !== "1" ? "none" : "",
                        }}
                      >
                        <img
                          className="itemImage"
                          src={
                            mouseHover === module.id || selected === module.id
                              ? module.imgHover
                              : module.img
                          }
                          alt=""
                        />
                        {collapse === false ? (
                          <div className="itemName">
                            {module.name}
                            {isMyTasks && activeTasksCount > 0 && (
                              <span className="task-count">{activeTasksCount}</span>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    );
                  }
                }
                return null;
              });
            })()
          ) : userData && userData.data.roleName === "Admin" ? (
            // Show modules for Admin role (correctAttendance excluded)
            (() => {
              // Get modules from userData.data.tabs and add essential modules
              const adminTabs = userData.data.tabs ? Object.keys(userData.data.tabs) : [];
              
              // Start with My Tasks first, then add other modules
              const allAdminModules = ['myTasks'];
              
              // Add other tabs (excluding myTasks to avoid duplicates)
              adminTabs.forEach(tab => {
                if (tab !== 'myTasks' && !allAdminModules.includes(tab)) {
                  allAdminModules.push(tab);
                }
              });
              
              // Add other essential modules if not already present
              const essentialModules = ['resourceAllocation', 'sow', 'sowAllocations', 'veersaPoints', 'pointsDashboard'];
              essentialModules.forEach(module => {
                if (!allAdminModules.includes(module)) {
                  allAdminModules.push(module);
                }
              });

              const orderedAdminModules = orderVeersaPointsAfterMyTasks(allAdminModules);

              return orderedAdminModules.map((moduleName, index) => {
                let module = ModuleList.find(e => e.key === moduleName);
                if (module) {
                  let sidebarClass = getSidebarClass(module.id);
                  if(module.id !== "9" && module.id !== "16") {
                    // Special handling for My Tasks to show task count
                    const isMyTasks = moduleName === 'myTasks';
                    const activeTasksCount = isMyTasks ? getActiveTasksCount() : 0;
                    
                    return (
                      <div
                        key={index}
                        className={sidebarClass}
                        onClick={() => {
                          changePage(module.name);
                          setSelected(module.id);
                        }}
                        onMouseOver={() => setMouseHover(module.id)}
                        onMouseOut={() => setMouseHover(-1)}
                        style={{
                          display:
                            pageName === "Dashboard" && module.id !== "1" ? "none" : "",
                        }}
                      >
                        <img
                          className="itemImage"
                          src={
                            mouseHover === module.id || selected === module.id
                              ? module.imgHover
                              : module.img
                          }
                          alt=""
                        />
                        {collapse === false ? (
                          <div className="itemName">
                            {module.name}
                            {isMyTasks && activeTasksCount > 0 && (
                              <span className="task-count">{activeTasksCount}</span>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    );
                  }
                }
                return null;
              });
            })()
          ) : (
            // Show modules based on userData.data.tabs for other roles  
            userData && (() => {
              const userTabs = Object.keys(userData.data.tabs || {});
              
              // Start with My Tasks first, then add other modules
              const allModules = ['myTasks'];
              
              // Add user tabs (excluding myTasks to avoid duplicates)
              userTabs.forEach(tab => {
                if (tab !== 'myTasks' && !allModules.includes(tab)) {
                  allModules.push(tab);
                }
              });

              if (!allModules.includes('veersaPoints')) {
                allModules.push('veersaPoints');
              }

              const orderedUserModules = orderVeersaPointsAfterMyTasks(
                allModules.filter((k) => k !== "pointsDashboard")
              );

              // Note: Resource Allocation is only available for Admin users

              return orderedUserModules.map((moduleName, index) => {
                let module = ModuleList.find(e => e.key === moduleName);
                if (module) {
                  let sidebarClass = getSidebarClass(module.id);
                  if(module.id !== "9" && module.id !== "16") {
                    // Special handling for My Tasks to show task count
                    const isMyTasks = moduleName === 'myTasks';
                    const activeTasksCount = isMyTasks ? getActiveTasksCount() : 0;
                    
                    return (
                      <div
                        key={index}
                        className={sidebarClass}
                        onClick={() => {
                          changePage(module.name);
                          setSelected(module.id);
                        }}
                        onMouseOver={() => setMouseHover(module.id)}
                        onMouseOut={() => setMouseHover(-1)}
                        style={{
                          display:
                            pageName === "Dashboard" && module.id !== "1" ? "none" : "",
                        }}
                      >
                        <img
                          className="itemImage"
                          src={
                            mouseHover === module.id || selected === module.id
                              ? module.imgHover
                              : module.img
                          }
                          alt=""
                        />
                        {collapse === false ? (
                          <div className="itemName">
                            {module.name}
                            {isMyTasks && activeTasksCount > 0 && (
                              <span className="task-count">{activeTasksCount}</span>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    );
                  }
                }
                return null;
              });
            })()
          )}
        </div>
        <div className="bottomItems">
          <div className="divider" />
          <div
            className={
              selected === "9" ?
              `sidebarItemsSelected ${userData?.data?.roleName === "Admin" ? "" : "displayNone"}` :
              `sidebarItems ${userData?.data?.roleName === "Admin" ? "" : "displayNone"}`
             
            }
            onClick={() => {
              changePage("Settings");
              setSelected("9");
            }}
            onMouseOver={() => setMouseHover("9")}
            onMouseOut={() => setMouseHover("-1")}
          >
            <img
              className="itemImage"
              src={
                mouseHover === "9" || selected === "9"
                  ? settingBlueIcon
                  : settingsImg
              }
              alt=""
            />
            {collapse === false ? <div className="itemName">Settings</div> : ""}
          </div>
          <div
            className="sidebarItems"
            onClick={() => signOutHandler()}
            onMouseOver={() => setMouseHover("logout")}
            onMouseOut={() => setMouseHover("-1")}
          >
            <img
              className="itemImage"
              src={mouseHover === "logout" ? logoutBlueIcon : logoutImg}
              alt=""
            />
            {collapse === false ? <div className="itemName">Logout</div> : ""}
          </div>
          <div id="collapse_buttom">
            <img
              className="arrowIcon"
              src={collapse === false ? collapseArrowImg : openArrowImg}
              alt=""
              onClick={() => {
                setCollapse(!collapse);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
 
 